import { useMediaQuery, useTheme } from '@mui/material'

/**
 * Responsive hooks — single source of truth cho viewport branching.
 *
 * BREAKPOINTS (MUI default):
 *   - xs:   0px
 *   - sm:   600px
 *   - md:   900px
 *   - lg:   1200px
 *   - xl:   1536px
 *
 * Use cases:
 *   - useIsMobile: true khi < sm (phone portrait) — dùng cho fullScreen dialog,
 *     stack vertical buttons, hide secondary info.
 *   - useIsTablet: true khi < md (phone + tablet) — dùng cho sidebar Drawer
 *     temporary vs permanent (Layout.tsx pattern).
 *   - useIsDesktop: true khi >= md — dùng để show desktop-only features
 *     (hover tooltip, multi-pane, ...).
 *
 * KHÔNG hardcode `useMediaQuery(theme.breakpoints.down('sm'))` rải rác — luôn
 * import hook từ đây để consistent + dễ thay breakpoint sau này.
 */

/** True khi viewport < sm (phone portrait, < 600px). */
export function useIsMobile(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('sm'))
}

/** True khi viewport < md (phone + tablet, < 900px). */
export function useIsTablet(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('md'))
}

/** True khi viewport >= md (desktop, >= 900px). */
export function useIsDesktop(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up('md'))
}
